import { Button } from "src/components/buttons";
import { withShowToggle } from "src/components/hoc/withShowToggle";

import { ButtonProps } from "./types";

export const ReviewConfiguration = withShowToggle(
  ({ handleAction }: ButtonProps) => {
    return (
      <Button name="review-configuration" kind="primary" onClick={handleAction}>
        Review configuration
      </Button>
    );
  }
);
